import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";
import { forwardRef } from "react";

import styles from "./content.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Content = forwardRef<HTMLDivElement, Props>(
    ({ children, className, ...props }, ref) => (
        <div ref={ref} className={clsx(styles.content, className)} {...props}>
            {children}
        </div>
    ),
);
Content.displayName = "Content";

export { Content };
export type { Props as ContentProps };
